export class LayerModel {
  id?: number = null;
  cod: string = null;
  designServiceId: string = null;
  designServices?: any = null;
  description?: any = null;


  constructor(id?: number, cod?: string, designServiceId?: string, designServices?: any, description?: any) {
    this.id = id;
    this.cod = cod;
    this.designServiceId = designServiceId;
    this.designServices = designServices;
    this.description = description;
  }
}
